import { render, staticRenderFns } from "./createCompaign.vue?vue&type=template&id=37b92ae8&scoped=true"
import script from "./createCompaign.vue?vue&type=script&lang=js"
export * from "./createCompaign.vue?vue&type=script&lang=js"
import style0 from "./createCompaign.vue?vue&type=style&index=0&id=37b92ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b92ae8",
  null
  
)

export default component.exports